import { useMutation } from '@tanstack/react-query';
import { experimentalUploadEpisodeImage } from '@/api';
import camelcaseKeys from 'camelcase-keys';

const transform = (data) => {
    // TODO: Do camelcase transformation in Axios interceptor
    return camelcaseKeys(data, { deep: true });
};

const mutationFn = async ({ episodeId, image }) => {
    const { data } = await experimentalUploadEpisodeImage(episodeId, image);

    return transform(data);
};

const useAddEpisodeImageMutation = () => {
    return useMutation({
        mutationFn,
        onSuccess: () => {
            // Invalidation of episode query is handled in useSaveEpisodeFormMutation
        },
    });
};

export default useAddEpisodeImageMutation;
